<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row align-content="center" justify="center" class="pl-3">
            <v-card max-width="210" v-for="(lib,index) in libData" :key="index" class="xs4 md3 lg2 mt-3">
                <v-img v-if="src[index]" max-height="200px" contain
                       :src="src[index].img"/>
                <v-card-title>{{ lib.title }}</v-card-title>
                <v-card-subtitle>Год: {{ lib.year }}</v-card-subtitle>
                <v-card-text>{{ lib.summary.substr(0, 150).split(/ (?=\S+$)/)[0] }}...</v-card-text>
            </v-card>
        </v-row>
        <v-btn v-scroll="onScroll" class="mb-8" v-show="fab" fab dark fixed bottom left @click="toTop">
            <v-icon>mdi-arrow-up-bold-circle</v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "detailLibrary",
    props: {
        libId: {
            default: 0
        }
    },
    data() {
        return {
            fab: false,
            overlay: true,
            libData: [],
            src: []
        }
    },
    created() {
        this.open(this.libId)
    },
    methods: {
        onScroll(e) {
            if (typeof window === 'undefined') return
            const top = window.pageYOffset || e.target.scrollTop || 0
            this.fab = top > 20
        },
        toTop() {
            this.$vuetify.goTo(0)
        },
        async open(id) {
            await this.$http.get('/getDataLibrary/' + id).then(async (resp) => {
                this.libData = resp.data
            })
            this.overlay = false
            for (let dataForImg of this.libData) {
                await this.image(dataForImg.thumb)
            }
        },
        async image(route) {
            await this.$http.post('/photo', {route: route}, {
                responseType: 'blob'
            }).then((resp) => {
                let reader = new FileReader()
                reader.readAsDataURL(resp.data)
                reader.onload = () => {
                    this.src.push({img: reader.result})
                }
            })
        }
    }
}
</script>

<style scoped>
.v-card {
    margin-right: 20px !important;
}

.v-card__title {
    font-size: 1.05rem !important;
}

.v-image {
    background-color: black !important;
}
</style>